module.exports = __webpack_public_path__ + "static/img/slgman.4e14bd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/20210918/slgman.jpg
// module id = aJVT
// module chunks = 1